import axios from "axios";
import { getUtmParams } from "@/lib/utm";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
});

export async function submitLead(payload) {
    const utm = getUtmParams();
    const body = {
        ...payload,
        utm_source: payload.utm_source || utm.utm_source,
        utm_medium: payload.utm_medium || utm.utm_medium,
        utm_campaign: payload.utm_campaign || utm.utm_campaign,
        utm_term: payload.utm_term || utm.utm_term,
        utm_content: payload.utm_content || utm.utm_content,
        referrer: payload.referrer || utm.referrer,
        pagina:
            payload.pagina ||
            (typeof window !== "undefined"
                ? window.location.pathname
                : undefined),
    };
    const { data } = await api.post("/leads", body);
    return data;
}

export async function submitCatalogLead(payload) {
    const utm = getUtmParams();
    const body = {
        ...payload,
        utm_source: utm.utm_source,
        utm_medium: utm.utm_medium,
        utm_campaign: utm.utm_campaign,
        referrer: utm.referrer,
        pagina:
            typeof window !== "undefined"
                ? window.location.pathname
                : undefined,
    };
    const { data } = await api.post("/leads/catalog", body);
    return data;
}

export async function trackEvent(payload) {
    try {
        const utm = getUtmParams();
        await api.post("/events", {
            ...payload,
            utm_source: utm.utm_source,
            utm_medium: utm.utm_medium,
            utm_campaign: utm.utm_campaign,
            referrer: utm.referrer,
            path:
                payload.path ||
                (typeof window !== "undefined"
                    ? window.location.pathname
                    : undefined),
        });
    } catch (e) {
        /* best-effort */
    }
}
